// extracted by mini-css-extract-plugin
module.exports = {"tags":"tags-module--tags--CY1-e","tagsTitle":"tags-module--tagsTitle--1tTL5","noTags":"tags-module--noTags--8j541"};